import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FiSmartphone, FiRefreshCw } from 'react-icons/fi';

const CAMPS = [
  { value: '', label: 'All Campaigns' },
  { value: 'medicare', label: 'Medicare' },
  { value: 'aca', label: 'ACA' },
];

const S = {
  sel: { padding: '8px 12px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '14px', minWidth: '160px' },
  btn: { display:'flex', alignItems:'center', padding:'8px 16px', background:'#1a56db', color:'#fff', border:'none', borderRadius:'6px', cursor:'pointer', fontSize:'14px' },
  th: { padding:'10px 14px', textAlign:'left', fontWeight:600, color:'#374151', borderBottom:'1px solid #e5e7eb', background:'#f9fafb', whiteSpace:'nowrap' },
  td: { padding:'10px 14px', borderBottom:'1px solid #f3f4f6' },
};

const bge = (color, txt) => (
  <span style={{display:'inline-block',padding:'2px 8px',borderRadius:'12px',background:color+'20',color,fontWeight:600,fontSize:'12px'}}>{txt}</span>
);

const platBadge = p => {
  if (p==='ios') return bge('#1a56db','📱 iOS');
  if (p==='android') return bge('#16a34a','🤖 Android');
  return bge('#6b7280','🌐 Web/No App');
};

const fmt = d => d ? new Date(d).toLocaleDateString() : '—';

function AgentAppStats({ token }) {
  const [leads, setLeads] = useState([]);
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(false);
  const [campaign, setCampaign] = useState('');
  const [search, setSearch] = useState('');

  useEffect(() => { fetch(); }, [campaign]);

  const fetch = async () => {
    setLoading(true);
    try {
      const q = campaign ? `?campaign=${campaign}` : '';
      const r = await axios.get(`/api/lead-portal/agent/app-stats${q}`, { headers: { Authorization: `Bearer ${token}` } });
      setLeads(r.data.leads || []);
      setSummary(r.data.summary || null);
    } catch(e) { console.error(e); }
    finally { setLoading(false); }
  };

  const rows = leads.filter(l => {
    if (!search) return true;
    const t = search.toLowerCase();
    return (l.leadEmail||'').toLowerCase().includes(t)||(l.leadName||'').toLowerCase().includes(t)||(l.leadPhone||'').toLowerCase().includes(t);
  });

  return (
    <div style={{padding:'24px'}}>
      <h1 style={{fontSize:'22px',fontWeight:700,marginBottom:'4px',display:'flex',alignItems:'center',gap:8}}>
        <FiSmartphone/>My Leads — App Usage Stats
      </h1>
      <p style={{color:'#6b7280',marginBottom:'20px'}}>Track which leads downloaded the app and on which platform.</p>

      <div style={{display:'flex',gap:'12px',flexWrap:'wrap',marginBottom:'20px',alignItems:'center'}}>
        <select value={campaign} onChange={e=>setCampaign(e.target.value)} style={S.sel}>
          {CAMPS.map(o=><option key={o.value} value={o.value}>{o.label}</option>)}
        </select>
        <input placeholder="Search name/email/phone..." value={search} onChange={e=>setSearch(e.target.value)} style={{...S.sel,width:'240px'}}/>
        <button onClick={fetch} style={S.btn} disabled={loading}>
          <FiRefreshCw style={{marginRight:4}}/>{loading?'Loading...':'Refresh'}
        </button>
      </div>

      {summary && (
        <div style={{display:'flex',gap:'12px',flexWrap:'wrap',marginBottom:'24px'}}>
          {[['Total Leads',summary.total,'#1a56db'],['Downloaded App',summary.hasApp,'#16a34a'],
            ['iOS',summary.ios,'#7c3aed'],['Android',summary.android,'#d97706'],['No App',summary.noApp,'#6b7280']
          ].map(([label,val,col])=>(
            <div key={label} style={{background:'#fff',border:'1px solid #e5e7eb',borderTop:`3px solid ${col}`,borderRadius:'10px',padding:'14px 20px',minWidth:'110px',textAlign:'center'}}>
              <div style={{fontSize:'24px',fontWeight:700,color:col}}>{val}</div>
              <div style={{fontSize:'12px',color:'#6b7280',marginTop:2}}>{label}</div>
            </div>
          ))}
        </div>
      )}

      {loading ? <div style={{textAlign:'center',padding:'40px',color:'#6b7280'}}>Loading...</div> : (
        <div style={{overflowX:'auto'}}>
          <table style={{width:'100%',borderCollapse:'collapse',border:'1px solid #e5e7eb',fontSize:'14px'}}>
            <thead>
              <tr>
                {['Lead','Phone','Campaign','App Platform','App First Seen','Last Login'].map(h=>(
                  <th key={h} style={S.th}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.length===0 ? (
                <tr><td colSpan={6} style={{textAlign:'center',padding:'32px',color:'#6b7280'}}>No leads found</td></tr>
              ) : rows.map((l,i)=>(
                <tr key={l.leadEmail} style={{background:i%2===0?'#fff':'#f9fafb'}}>
                  <td style={S.td}>
                    <div style={{fontWeight:600,color:'#111827',fontSize:'13px'}}>{l.leadName||'—'}</div>
                    <div style={{fontSize:'11px',color:'#6b7280',marginTop:2}}>{l.leadEmail}</div>
                  </td>
                  <td style={S.td}>{l.leadPhone||'—'}</td>
                  <td style={S.td}>{l.campaigns.map(c=><span key={c} style={{display:'inline-block',padding:'2px 7px',borderRadius:'10px',background:'#1a56db18',color:'#1a56db',fontSize:'11px',fontWeight:600,marginRight:3,textTransform:'uppercase'}}>{c}</span>)}</td>
                  <td style={S.td}>{platBadge(l.appPlatform)}</td>
                  <td style={S.td}>{fmt(l.appFirstSeen)}</td>
                  <td style={S.td}>{fmt(l.lastLogin)}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <div style={{color:'#6b7280',fontSize:'13px',marginTop:6}}>Showing {rows.length} of {leads.length} leads</div>
        </div>
      )}
    </div>
  );
}

export default AgentAppStats;
